// PhoneCanvas масштабирует макет через CSS `zoom`. dnd-kit's sorting strategies
// (e.g. verticalListSortingStrategy) compute the DISPLACEMENT transform for
// every non-dragged item from `getBoundingClientRect()` — already-zoomed
// (screen) px — and that transform is then applied INSIDE the zoom container,
// where 1 CSS-px = `scale` screen px. Left undivided, the other items slide by
// only `scale`× the distance they actually need to cover: the preview shows
// them displacing less than where the drop (corrected by scaleCollision) will
// actually land. createScaleModifier already applies this same division to
// the DRAGGED item's transform — this wraps a strategy so the displacement
// transform for every OTHER item follows the same convention.
import type { SortingStrategy } from '@dnd-kit/sortable'

export const createScaledStrategy =
  (scale: number, strategy: SortingStrategy): SortingStrategy =>
  (args) => {
    const transform = strategy(args)
    if (!transform || !scale || scale <= 0) return transform
    return { ...transform, x: transform.x / scale, y: transform.y / scale }
  }
